/**
 *  idType 证件类型
    _1(1, "","身份证"),
    _2(2, "","护照"),
    _3(3, "","驾照"),
    _4(4, "","军人证"),
    _5(5, "","回乡证"),
    _6(6, "","港澳通行证"),
    _7(7, "","台胞证"),
    _8(8, "","其他"),
    _9(9, "","台湾通行证"),
    _10(10, "","国际海员证"),
    _11(11, "","出生证明"),
    _12(12, "","户口簿"),
    _13(13, "","外国人永久居留证"),
    _14(14, "","残疾军人证"),
    _15(15, "","伤残人民警察证"),
    _16(16, "","台湾身份证"),
    _17(17, "","港澳居民居住证"),
    _18(18, "","台湾居民居住证"),
    _20(20, "","外国人永久居留身份证"),
    _21(21, "","香港永久性居民身份证"),
    _22(22, "","香港居民身份证"),
    _23(23, "","澳门特别行政区居民身份证"),
    _24(24, "","澳门特别行政区非永久性居民身份证"),
    _25(25, "","永久居民身份证（新加坡）"),
    _26(26, "","外国人身份证"),
 */

export {}
